import { DecimalPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdjDefLabelPipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-adjustment-grid",
	imports: [FormsModule, DecimalPipe, AdjDefLabelPipe],
	templateUrl: "./adjustment-grid.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AdjustmentGridComponent {
	@Input()
	public rotor: APIResults.Rotor;
	// Mutated in place via ngModel, so the host's bound array reflects edits directly
	@Input()
	public adjustments: number[][] | string[][];
	// "number" numeric inputs, "h60" text inputs with the H60 validation pattern
	@Input()
	public mode: "number" | "h60" = "number";
	// When provided, each row shows an expandable list of alternate values
	@Input()
	public alternates?: number[][][] | string[][][];
	// Companion to alternates: per-row expanded/collapsed state (mutated in place)
	@Input()
	public adjDetail?: boolean[];
	// When provided with more than one entry, a per-row select checkbox column is shown
	@Input()
	public adjustmentSelect?: boolean[];
	// Track adjustments show the header blade names reversed for clockwise rotors (cells stay in natural order)
	@Input()
	public reorderHeaderForClockwise = false;
	// Track adjustments hide the 'WTS' adjdef
	@Input()
	public excludeWts = false;

	// keyup.enter in an input (host applies the manual adjustment)
	@Output()
	public enter = new EventEmitter<void>();
	// A select checkbox toggled (host refreshes the plot)
	@Output()
	public selectChange = new EventEmitter<void>();
	// An alternate row was clicked; emits the row/alternate indices
	@Output()
	public alternateSelect = new EventEmitter<{ row: number; alt: number }>();

	public filterBlades(displaygroup: string) {
		return this.rotor.blade.filter(item => item.displaygroup === displaygroup);
	}

	// Header blades for a display group — reversed for clockwise rotors when reorderHeaderForClockwise is set
	public headerBlades(displaygroup: string) {
		const blades = this.filterBlades(displaygroup);
		return this.reorderHeaderForClockwise ? this.reorderBlades(blades) : blades;
	}

	private reorderBlades(blades: APIResults.Rotor["blade"]) {
		if (this.rotor.balancedata.clockwise && blades.length > 1) {
			// Reorder blades if clockwise, see email "sorry, learned something new" 9/24/2025
			const reordered = blades.slice().reverse();
			reordered.unshift(reordered.pop()!);
			return reordered;
		}
		return blades;
	}
}
